import { Request, Response } from 'express';
import { join } from 'path';
import fs from 'fs';

import { serializeError, ensureDir } from './utils';

interface CollectLogRequest {
  level: string;
  message: string;
  time: string; // ISO String
  source?: string; // Log Source string
  user_id: string; // User ID
  tenant_id: string; // Tenant ID
  app_id: string; // App ID
}

export function collectLogsHandler(logDir: string, fileName: string) {
  const filePath = join(logDir, fileName);
  // Ensure log directory exists
  ensureDir(logDir);

  return async (req: Request, res: Response) => {
    try {
      const logContent = req.body as CollectLogRequest;
      if(!logContent.message){
        return res.status(400).json({ message: 'message is required' });
      }
      const logLine = JSON.stringify({
        ...logContent,
        server_time: new Date().toISOString(),
      }) + '\n';
      await fs.promises.appendFile(filePath, logLine);
      res.json({
        success: true,
      });
    } catch (error) {
      handleError(res, error, 'Failed to collect logs');
    }
  };
}
export function collectLogsBatchHandler(logDir: string, fileName: string) {
  const filePath = join(logDir, fileName);
  // Ensure log directory exists
  ensureDir(logDir);

  return async (req: Request, res: Response) => {
    try {
      const logContents = req.body as Array<CollectLogRequest>;
      if(!Array.isArray(logContents)){
        return res.status(400).json({ message: 'logContents must be an array' });
      }
      const logLines = [];
      for (const logContent of logContents) {
        logLines.push(JSON.stringify({
          ...logContent,
          server_time: new Date().toISOString(),
        }) + '\n');
      }
      await fs.promises.appendFile(filePath, logLines.join(''));
      res.json({
        success: true,
      });
    } catch (error) {
      handleError(res, error, 'Failed to collect logs');
    }
  };
}

function handleError(res: Response, error: unknown, message = 'Failed to collect logs'): void {
  res.status(500).json({ message, error: serializeError(error) });
}